window.onscroll = function() { scrollFunction() };

function scrollFunction() {
  const btn = document.getElementById("toTopBtn");

  if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
    toTopBtn.classList.add("show");
  } else {
    toTopBtn.classList.remove("show");
  }
}


function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' 
  });
}